import { useEnsureAIHubSharedExecutionContext } from '@office-start/ai-hub-execution-context-provider-lazy';
import { AiHubPageUnstyled } from '@office-start/ai-hub-page-component';
import { logModuleLoadDuration } from '@office-start/ai-hub-telemetry-service';
import { useLogPageView } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
var componentName = 'CollectComponent';
var CollectComponentLazy = lazy(function () {
    var loadPromise = import(
    /* webpackChunkName: "collect" */ '@fluidx/ai-hub-collect').then(function (module) { return ({ default: module.CollectAIHubModule }); });
    return logModuleLoadDuration(loadPromise, componentName);
});
export var CollectPage = function () {
    // while we download the collect component, we need to ensure the AIHub shared execution context is loaded
    // this is because the collect component uses the AIHub shared execution context in both V3 and V2
    useEnsureAIHubSharedExecutionContext();
    return (React.createElement(AiHubPageUnstyled, { useLogPageViewHook: useLogPageView, name: "Collect", LazyComponent: CollectComponentLazy, componentName: componentName }));
};
//# sourceMappingURL=CollectPage.js.map